import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import "react-datepicker/dist/react-datepicker.css";
import { Row, Col, Form, Modal, Table } from "react-bootstrap";
import { FaPlus, FaTimes } from "react-icons/fa";

const hasOutstandingBalance = (value) => Number(value || 0) > 0;

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    viewOption: "outstanding",
    organizationName: "",
    numParticipants: "",
    trainingModule: "",
    academicSession: "",
  });
  const [showAdditionalTable, setShowAdditionalTable] = useState({});
  const [error, setError] = useState("");
  const [outstandingRows, setOutstandingRows] = useState([]);
  const [loadingRows, setLoadingRows] = useState(true);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

  const paymentMethods = [
    { value: "Bank Transfer", label: "Bank Transfer" },
    { value: "UPI", label: "UPI" },
  ];

  const handleToggle = (rowId) => {
    setShowAdditionalTable((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "viewOption" && value === "payment") {
      navigate("/student/payment-gateway");
    }
  };

  useEffect(() => {
    const fetchStudentOutstandingHeader = async () => {
      const studentId = sessionStorage.getItem("userId");
      const academicYearId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      if (!studentId || !academicYearId) {
        setError("Student session details are missing. Please log in again.");
        setLoadingRows(false);
        return;
      }

      try {
        setError("");

        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentProfile/${studentId}/?academic_year_id=${academicYearId}`
        );

        const contentType = response.headers.get("content-type") || "";
        const payload = contentType.includes("application/json")
          ? await response.json()
          : null;

        if (!response.ok || !payload || payload.message !== "Success") {
          throw new Error(payload?.message || "Unable to load student details.");
        }

        const student = payload.data || {};
        setFormData((prev) => ({
          ...prev,
          organizationName: student.studentname || "",
          numParticipants: student.classname || "",
          trainingModule: student.sectionname || "",
          academicSession: student.academic_year || "",
        }));

        const queryParams = new URLSearchParams();
        queryParams.append("academic_year_id", academicYearId);
        if (orgId) queryParams.append("org_id", orgId);
        if (branchId) queryParams.append("branch_id", branchId);

        const outstandingResponse = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentOutstandingFees/${studentId}/?${queryParams.toString()}`
        );
        const outstandingContentType = outstandingResponse.headers.get("content-type") || "";
        const outstandingPayload = outstandingContentType.includes("application/json")
          ? await outstandingResponse.json()
          : null;

        if (!outstandingResponse.ok || !outstandingPayload || outstandingPayload.message !== "Success") {
          throw new Error(outstandingPayload?.message || "Unable to load outstanding fee details.");
        }

        const outstandingData = Array.isArray(outstandingPayload.data)
          ? outstandingPayload.data
              .map((row) => ({
                ...row,
                details: Array.isArray(row.details)
                  ? row.details.filter((item) => hasOutstandingBalance(item.balance))
                  : [],
              }))
              .filter((row) => hasOutstandingBalance(row.balance))
          : [];

        setOutstandingRows(outstandingData);

      } catch (fetchError) {
        console.error("Error fetching outstanding student details:", fetchError);
        setError(fetchError.message || "Unable to load student details.");
        setOutstandingRows([]);
      } finally {
        setLoadingRows(false);
      }
    };

    fetchStudentOutstandingHeader();
  }, []);

  const openPaymentModal = (receipt) => {
    setSelectedReceipt(receipt);
    setSelectedPaymentMethod("");
    setShowPaymentModal(true);
  };

  const closePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedReceipt(null);
    setSelectedPaymentMethod("");
  };

  const handleProceedToPay = () => {
    const amount = selectedReceipt?.balance ?? 0;
    const feeCount = Array.isArray(selectedReceipt?.details)
      ? selectedReceipt.details.filter((item) => Number(item.balance || 0) > 0).length
      : 0;

    alert(
      `Payment of Rs.${Number(amount).toFixed(2)} will be processed for ${feeCount || 1} selected fee(s).\n\nNote: Payment integration will be implemented here.`
    );
    closePaymentModal();
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-2">
            <div className="card-body">
              <p
                className="text-center fw-bold mb-3"
                style={{ fontSize: "18px" }}
              >
                PAYMENT DETAILS
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/student/dashboards")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {error ? <div className="alert alert-danger">{error}</div> : null}

              <div className="row mt-3 mx-2 mt-2">
                <div className="col-12 custom-section-box">
                  <Row className="justify-content-center">
                    <Col
                      className="p-3"
                      xs={12}
                      sm={8}
                      // style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                    >
                      <Form>
                        <Row className="mb-1 mt-4">
                          <Col md={6} className="py-0">
                            <Form.Label className="mb-1">
                              Student Name{" "}
                            </Form.Label>
                          </Col>
                          <Col md={6} className="py-0">
                            <Form.Control
                              type="text"
                              className="form-control form-control-sm detail"
                              name="organizationName"
                              value={formData.organizationName}
                              onChange={handleChange}
                              readOnly
                            />
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={6}>
                            <Form.Label>
                              Class <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                          </Col>
                          <Col md={6}>
                            <Form.Control
                              type="text"
                              name="numParticipants"
                              className="form-control detail"
                              value={formData.numParticipants}
                              onChange={handleChange}
                              readOnly
                            />
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={6}>
                            <Form.Label>Section</Form.Label>
                          </Col>
                          <Col md={6}>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              name="trainingModule"
                              value={formData.trainingModule}
                              onChange={handleChange}
                              readOnly
                            />
                          </Col>
                        </Row>
                        <Row className="mb-1">
                          <Col md={6}>
                            <Form.Label>Academic Session</Form.Label>
                          </Col>
                          <Col md={6}>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              name="academicSession"
                              value={formData.academicSession}
                              onChange={handleChange}
                              readOnly
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3 mt-5">
                          <Col
                            md={{ span: 7, offset: 7 }}
                            className="d-flex justify-content-end"
                          >
                            <Form.Check
                              type="radio"
                              id="viewOutstanding"
                              label="View Outstanding Details"
                              name="viewOption"
                              value="outstanding"
                              checked={formData.viewOption === "outstanding"}
                              onChange={handleChange}
                              className="me-3"
                            />
                            <Form.Check
                              type="radio"
                              id="viewPayment"
                              label="View Payment Details"
                              name="viewOption"
                              value="payment"
                              checked={formData.viewOption === "payment"}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="col-12">
                <div className="table-responsive">
                  <Table bordered>
                    <thead>
                      <tr>
                        <th></th>
                        <th>Period</th>
                        <th>Total Amount</th>
                        <th>Paid Amount</th>
                        <th>Discount </th>
                        <th>Balance</th>
                        <th>Pay</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingRows ? (
                        <tr>
                          <td colSpan="7" className="text-center">
                            Loading outstanding fee details...
                          </td>
                        </tr>
                      ) : outstandingRows.length > 0 ? (
                        outstandingRows.map((receipt) => (
                          <React.Fragment key={receipt.id}>
                            <tr>
                              <td>
                                <FaPlus
                                  onClick={() => handleToggle(receipt.id)}
                                  style={{ cursor: "pointer" }}
                                />
                              </td>
                              <td>{receipt.period || "-"}</td>
                              <td>{receipt.total_amount ?? 0}</td>
                              <td>{receipt.paid_amount ?? 0}</td>
                              <td>{receipt.discount_amount ?? 0}</td>
                              <td>{receipt.balance ?? 0}</td>
                              <td>
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => openPaymentModal(receipt)}
                                >
                                  Pay Now
                                </button>
                              </td>
                            </tr>

                            {showAdditionalTable[receipt.id] && (
                              <tr>
                                <td colSpan="7">
                                  <Table bordered>
                                    <thead>
                                      <tr>
                                        <th>Element Name</th>
                                        <th>Amount</th>
                                        <th>Paid</th>
                                        <th>Balance</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Array.isArray(receipt.details) && receipt.details.length > 0 ? (
                                        receipt.details.map((item, itemIdx) => (
                                          <tr key={itemIdx}>
                                            <td>{item.fee_head || "-"}</td>
                                            <td>{item.amount ?? 0}</td>
                                            <td>{item.paid ?? 0}</td>
                                            <td>{item.balance ?? 0}</td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="4" className="text-center">
                                            No fee element details found
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No pending fee records found for this student
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showPaymentModal} onHide={closePaymentModal} centered backdrop="static">
        <Modal.Body style={{ padding: "0", borderRadius: "18px", overflow: "hidden" }}>
          <div style={{ background: "#1f7ae0", color: "#fff", padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: "22px", fontWeight: "700" }}>Make Payment</div>
            <button
              type="button"
              onClick={closePaymentModal}
              style={{ background: "transparent", border: "none", color: "#0f172a", fontSize: "24px" }}
            >
              <FaTimes />
            </button>
          </div>

          <div style={{ padding: "18px 18px 22px", background: "#ffffff" }}>
            <div
              style={{
                background: "#f3f6fb",
                borderRadius: "14px",
                padding: "18px",
                marginBottom: "18px",
              }}
            >
              <Row className="g-3">
                <Col md={6}>
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>Semester:</div>
                  <div style={{ fontSize: "17px", fontWeight: "700" }}>{selectedReceipt?.period || "-"}</div>
                </Col>
                <Col md={6}>
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>Fee Types:</div>
                  <div style={{ fontSize: "17px", fontWeight: "700" }}>
                    {selectedReceipt?.details?.filter((item) => Number(item.balance || 0) > 0).map((item) => item.fee_head).join(", ") || "-"}
                  </div>
                </Col>
                <Col md={6}>
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>Total Amount:</div>
                  <div style={{ fontSize: "17px", fontWeight: "700", color: "#0b63d1" }}>
                    Rs.{Number(selectedReceipt?.total_amount || 0).toFixed(2)}
                  </div>
                </Col>
                <Col md={6}>
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>Already Paid:</div>
                  <div style={{ fontSize: "17px", fontWeight: "700", color: "#16a34a" }}>
                    Rs.{Number(selectedReceipt?.paid_amount || 0).toFixed(2)}
                  </div>
                </Col>
                <Col md={6}>
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>Due Amount:</div>
                  <div style={{ fontSize: "17px", fontWeight: "700", color: "#dc2626" }}>
                    Rs.{Number(selectedReceipt?.balance || 0).toFixed(2)}
                  </div>
                </Col>
                <Col md={12}>
                  <div style={{ color: "#6b7280", fontSize: "14px" }}>
                    Selected Fees ({selectedReceipt?.details?.filter((item) => Number(item.balance || 0) > 0).length || 0}):
                  </div>
                  <div style={{ marginTop: "6px", color: "#475569" }}>
                    {selectedReceipt?.details?.filter((item) => Number(item.balance || 0) > 0).map((item) => item.fee_head).join(", ") || "-"}
                  </div>
                </Col>
              </Row>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <Form.Label style={{ fontWeight: "700" }}>
                Payment Amount <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={`Rs. ${Number(selectedReceipt?.balance || 0).toFixed(2)}`}
                readOnly
                style={{ height: "52px", borderRadius: "12px", borderColor: "#1677ff" }}
              />
              <div style={{ marginTop: "6px", color: "#6b7280" }}>
                You can pay any amount up to Rs.{Number(selectedReceipt?.balance || 0).toFixed(2)}
              </div>
            </div>

            <div style={{ marginBottom: "16px" }}>
              <Form.Label style={{ fontWeight: "700" }}>
                Payment Method <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Select
                value={selectedPaymentMethod}
                onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                style={{ height: "48px", borderRadius: "12px", borderColor: "#1677ff" }}
                >
                  <option value="">Select Payment Method</option>
                  {paymentMethods.map((method) => (
                    <option key={method.value} value={method.value}>
                      {method.label}
                    </option>
                  ))}
                </Form.Select>
            </div>

            <div
              style={{
                background: "#dbeafe",
                borderRadius: "12px",
                padding: "16px 18px",
                marginBottom: "18px",
              }}
            >
              <div style={{ color: "#6b7280", fontSize: "14px" }}>Amount to Pay:</div>
              <div style={{ color: "#0b63d1", fontSize: "18px", fontWeight: "800" }}>
                Rs.{Number(selectedReceipt?.balance || 0).toFixed(2)}
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                style={{ minWidth: "140px" }}
                onClick={closePaymentModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                style={{ minWidth: "170px" }}
                onClick={handleProceedToPay}
                disabled={!selectedPaymentMethod}
              >
                Proceed to Pay
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default AdmAttendanceEntry;
